import React from 'react'

const TheoryQuestion = ({ question, answer, onAnswerChange }) => {
  const handleAnswerChange = (e) => {
    onAnswerChange(e.target.value)
  }

  return (
    <div className="space-y-4">
      {/* Question Text */}
      {(question.question || question.text) && (
        <div className="bg-white p-4 rounded-lg border border-gray-200">
          <p className="text-lg text-gray-900 leading-relaxed">
            {question.question || question.text}
          </p>
        </div>
      )}
      
      <div>
        <label htmlFor={`answer-${question.id}`} className="block text-sm font-medium text-gray-700 mb-2">
          Your Answer:
        </label>
        <textarea
          id={`answer-${question.id}`}
          rows={8}
          value={answer || ''}
          onChange={handleAnswerChange}
          placeholder="Type your answer here..."
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none"
        />
      </div>
      
      {question.rubric && (
        <div className="bg-blue-50 p-4 rounded-lg">
          <h4 className="font-medium text-blue-900 mb-2">Marking Rubric:</h4>
          <p className="text-blue-800 text-sm">{question.rubric}</p>
        </div>
      )}
      
      <div className="text-sm text-gray-600">
        <p><strong>Marks:</strong> {question.marks}</p>
        <p><strong>Tip:</strong> Provide detailed explanations and examples to maximize your score.</p>
      </div>
    </div>
  )
}

export default TheoryQuestion
